export const updateProducts = ({ commit }, data) => {
    commit('UPDATE_PRODUCTS', data)
}
